import { Components, Theme } from "@mui/material"

export const MuiLinearProgress: Required<
  Components<Theme>
>["MuiLinearProgress"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      borderRadius: "999px",
      backgroundColor: palette["bg-secondary_subtle"],
    }),
    bar: {
      borderRadius: "999px",
    },
  },
}
